import { anyProp } from 'vue-ts-types';
import TextEditor from '@ebg/vue-common/src/components/common/texteditor/TextEditor.vue';

export default {
  name: 'OnboardingChecklistParams',
  components: {
    TextEditor
  },
  props: {
    params: {
      type: String | Object,
      default: null
    },
    values: {
      type: anyProp,
      default: null
    },
    item_id: {
      type: Number,
      default: null
    },
    group_value_id: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fieldsValues: []
    }
  },
  computed: {
    fields () {
      return this.params?.fields?.length > 0 ? this.params.fields : null;
    },
    localValue: {
      get () {
        return this.values;
      },
      set (newValue) {
        this.$emit('input', { item_id: this.item_id, value: newValue, group_value_id: this.group_value_id });
      }
    }
  },
  methods: {
    // A field may go without a label of its own - the "Komentārs" toggle is already named above its
    // editor, so repeating it read as two comments (HR-338).
    fieldLabel (field) {
      return field.label ? field.label[this.$i18n.locale] : null;
    }
  },
  mounted () {
  }
}
